import React from "react";

const FaceTracking: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 512 512"
    width={16}
    height={16}
    {...props}
  >
    <path
      fill="currentColor"
      d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 384c-97 0-176-79-176-176S159 80 256 80s176 79 176 176-79 176-176 176zm-80-216c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-35.3 0-64 14.3-80 32 16 17.7 44.7 32 80 32s64-14.3 80-32c-16-17.7-44.7-32-80-32z"
    />
    {/* Scan lines overlay */}
    <path
      fill="currentColor"
      opacity="0.4"
      d="M48 128h416M48 192h416M48 256h416M48 320h416M48 384h416"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export default FaceTracking;

export const FaceTrackingOff: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 640 512"
    width={16}
    height={16}
    {...props}
  >
    <path
      fill="currentColor"
      d="M320 48C205.1 48 112 141.1 112 256c0 35.2 8.8 68.4 24.3 97.4L45.5 434.2c-5.5 6.9-4.4 17 2.5 22.5l10 12.5c6.9 5.5 17 4.4 22.5-2.5l588-470.5c6.9-5.5 4.4-17-2.5-22.5l-10-12.5c-6.9-5.5-17-4.4-22.5 2.5L530.2 84.5C491.6 60.8 457.4 48 320 48zm0 384c-97 0-176-79-176-176 0-26.5 6-51.6 16.6-74.1l232.7 181.4c-20.6 42-61.6 68.7-73.3 68.7zm176-176c0 35.2-8.8 68.4-24.3 97.4l-371.4-289C139.6 124.8 173.8 112 320 112c97 0 176 79 176 176zM240 216c-17.7 0-32 14.3-32 32 0 4.4.9 8.6 2.5 12.5l41.5 32.4c7.5-3.5 13.5-9.5 16.5-17.1 4.5-11.5 1.5-24.7-6.5-33.5-8-8.8-17.5-14.3-22-16.3zm160 0c-4.5 0-14 7.5-22 16.3-8 8.8-11 22-6.5 33.5 3 7.6 9 13.6 16.5 17.1l41.5-32.4c1.6-3.9 2.5-8.1 2.5-12.5 0-17.7-14.3-32-32-32zm-80 128c-35.3 0-64 14.3-80 32 16 17.7 44.7 32 80 32s64-14.3 80-32c-16-17.7-44.7-32-80-32z"
    />
  </svg>
);
